import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProgramService {
  private programIdSource = new BehaviorSubject<number>(0);
  programId$ = this.programIdSource.asObservable();

  private programsUpdatedSource = new Subject<void>();
  programsUpdated$ = this.programsUpdatedSource.asObservable();

  constructor() {
    const storedId = localStorage.getItem('globalProgramId');
    this.programIdSource.next(storedId ? Number(storedId) : 0);
  }

  setProgramId(id: number): void {
    this.programIdSource.next(id);
    localStorage.setItem('globalProgramId', id.toString());
  }

  getProgramId(): number {
    return this.programIdSource.getValue();
  }

  notifyProgramsUpdated(): void {
    this.programsUpdatedSource.next();
  }
}
